<tc-cg-calendar
  [fromYear]="fromYear"
  [toYear]="toYear"
  [rangeGroups]="rangeGroups"
  [calendarRefreshEvent]="calendarRefreshEvent"
  [calendarMenuItems]="calendarMenuItems"
  (selectDate)="onSelectDate($event)"
  (menuItemClick)="onMenuItemClick($event)">
</tc-cg-calendar>
